"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _ApiClient = _interopRequireDefault(require("../ApiClient"));

var _Contact = _interopRequireDefault(require("../model/Contact"));

var _ContactResponse = _interopRequireDefault(require("../model/ContactResponse"));

var _ContactsExportDeleteResponse = _interopRequireDefault(require("../model/ContactsExportDeleteResponse"));

var _ContactsExportResponse = _interopRequireDefault(require("../model/ContactsExportResponse"));

var _ContactsExportsResponse = _interopRequireDefault(require("../model/ContactsExportsResponse"));

var _ContactsResponse = _interopRequireDefault(require("../model/ContactsResponse"));

var _CreateContactResponse = _interopRequireDefault(require("../model/CreateContactResponse"));

var _CreateContactsExportResponse = _interopRequireDefault(require("../model/CreateContactsExportResponse"));

var _DeleteContactResponse = _interopRequireDefault(require("../model/DeleteContactResponse"));

var _DoubleOptIn = _interopRequireDefault(require("../model/DoubleOptIn"));

var _DownloadContactsExportResponse = _interopRequireDefault(require("../model/DownloadContactsExportResponse"));

var _HTTPBadRequestError = _interopRequireDefault(require("../model/HTTPBadRequestError"));

var _HTTPValidationError = _interopRequireDefault(require("../model/HTTPValidationError"));

var _ImportContacts = _interopRequireDefault(require("../model/ImportContacts"));

var _ImportContactsResponse = _interopRequireDefault(require("../model/ImportContactsResponse"));

var _PatchContact = _interopRequireDefault(require("../model/PatchContact"));

var _PatchContactResponse = _interopRequireDefault(require("../model/PatchContactResponse"));

var _UnsubscribeContactResponse = _interopRequireDefault(require("../model/UnsubscribeContactResponse"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

/**
* Contact service.
* @module api/ContactApi
* @version integration550
*/
var ContactApi = /*#__PURE__*/function () {
  /**
  * Constructs a new ContactApi. 
  * @alias module:api/ContactApi
  * @class
  * @param {module:ApiClient} [apiClient] Optional API client implementation to use,
  * default to {@link module:ApiClient#instance} if unspecified.
  */
  function ContactApi(apiClient) {
    _classCallCheck(this, ContactApi);

    this.apiClient = apiClient || _ApiClient["default"].instance;
  }
  /**
   * Callback function to receive the result of the createContact operation.
   * @callback module:api/ContactApi~createContactCallback
   * @param {String} error Error message, if any.
   * @param {module:model/CreateContactResponse} data The data returned by the service call.
   * @param {String} response The complete HTTP response.
   */

  /**
   * Add a contact
   * @param {Number} listId 
   * @param {module:model/Contact} contact 
   * @param {Object} opts Optional parameters
   * @param {Number} opts.accountId 
   * @param {module:model/DoubleOptIn} opts.sendDoubleOptIn 
   * @param {module:api/ContactApi~createContactCallback} callback The callback function, accepting three arguments: error, data, response
   * data is of type: {@link module:model/CreateContactResponse}
   */


  _createClass(ContactApi, [{
    key: "createContact",
    value: function createContact(listId, contact, opts, callback) {
      opts = opts || {};
      var postBody = contact; // verify the required parameter 'listId' is set

      if (listId === undefined || listId === null) {
        throw new Error("Missing the required parameter 'listId' when calling createContact");
      } // verify the required parameter 'contact' is set


      if (contact === undefined || contact === null) {
        throw new Error("Missing the required parameter 'contact' when calling createContact");
      }

      var pathParams = {
        'list_id': listId
      };
      var queryParams = {
        'account_id': opts['accountId'],
        'send_double_opt_in': opts['sendDoubleOptIn']
      };
      var headerParams = {};
      var formParams = {};
      var authNames = ['OAuth2PasswordBearer'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = _CreateContactResponse["default"];
      return this.apiClient.callApi('/lists/{list_id}/contacts', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null, callback);
    }
    /**
     * Callback function to receive the result of the deleteContact operation.
     * @callback module:api/ContactApi~deleteContactCallback
     * @param {String} error Error message, if any.
     * @param {module:model/DeleteContactResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Delete a contact
     * @param {Number} listId 
     * @param {Number} contactId 
     * @param {Object} opts Optional parameters
     * @param {Number} opts.accountId 
     * @param {module:api/ContactApi~deleteContactCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/DeleteContactResponse}
     */

  }, {
    key: "deleteContact",
    value: function deleteContact(listId, contactId, opts, callback) {
      opts = opts || {};
      var postBody = null; // verify the required parameter 'listId' is set

      if (listId === undefined || listId === null) {
        throw new Error("Missing the required parameter 'listId' when calling deleteContact");
      } // verify the required parameter 'contactId' is set


      if (contactId === undefined || contactId === null) {
        throw new Error("Missing the required parameter 'contactId' when calling deleteContact");
      }

      var pathParams = {
        'list_id': listId,
        'contact_id': contactId
      };
      var queryParams = {
        'account_id': opts['accountId']
      };
      var headerParams = {};
      var formParams = {};
      var authNames = ['OAuth2PasswordBearer'];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = _DeleteContactResponse["default"];
      return this.apiClient.callApi('/lists/{list_id}/contacts/{contact_id}', 'DELETE', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null, callback);
    }
    /**
     * Callback function to receive the result of the deleteContactsExport operation.
     * @callback module:api/ContactApi~deleteContactsExportCallback
     * @param {String} error Error message, if any.
     * @param {module:model/ContactsExportDeleteResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Delete a Contacts Export
     * Delete a Contacts Export.
     * @param {String} exportId 
     * @param {Number} listId 
     * @param {Object} opts Optional parameters
     * @param {Number} opts.accountId 
     * @param {module:api/ContactApi~deleteContactsExportCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/ContactsExportDeleteResponse}
     */

  }, {
    key: "deleteContactsExport",
    value: function deleteContactsExport(exportId, listId, opts, callback) {
      opts = opts || {};
      var postBody = null; // verify the required parameter 'exportId' is set

      if (exportId === undefined || exportId === null) {
        throw new Error("Missing the required parameter 'exportId' when calling deleteContactsExport");
      } // verify the required parameter 'listId' is set


      if (listId === undefined || listId === null) {
        throw new Error("Missing the required parameter 'listId' when calling deleteContactsExport");
      }

      var pathParams = {
        'export_id': exportId,
        'list_id': listId
      };
      var queryParams = {
        'account_id': opts['accountId']
      };
      var headerParams = {};
      var formParams = {};
      var authNames = ['OAuth2PasswordBearer'];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = _ContactsExportDeleteResponse["default"];
      return this.apiClient.callApi('/lists/{list_id}/exports/{export_id}', 'DELETE', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null, callback);
    }
    /**
     * Callback function to receive the result of the downloadContactsExport operation.
     * @callback module:api/ContactApi~downloadContactsExportCallback
     * @param {String} error Error message, if any.
     * @param {module:model/DownloadContactsExportResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Download a Contacts Export
     * Download a Contacts Export.
     * @param {String} exportId 
     * @param {Number} listId 
     * @param {Object} opts Optional parameters
     * @param {Number} opts.accountId 
     * @param {module:api/ContactApi~downloadContactsExportCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/DownloadContactsExportResponse}
     */

  }, {
    key: "downloadContactsExport",
    value: function downloadContactsExport(exportId, listId, opts, callback) {
      opts = opts || {};
      var postBody = null; // verify the required parameter 'exportId' is set

      if (exportId === undefined || exportId === null) {
        throw new Error("Missing the required parameter 'exportId' when calling downloadContactsExport");
      } // verify the required parameter 'listId' is set


      if (listId === undefined || listId === null) {
        throw new Error("Missing the required parameter 'listId' when calling downloadContactsExport");
      }

      var pathParams = {
        'export_id': exportId,
        'list_id': listId
      };
      var queryParams = {
        'account_id': opts['accountId']
      };
      var headerParams = {};
      var formParams = {};
      var authNames = ['OAuth2PasswordBearer'];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = _DownloadContactsExportResponse["default"];
      return this.apiClient.callApi('/lists/{list_id}/exports/{export_id}/download', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null, callback);
    }
    /**
     * Callback function to receive the result of the exportContacts operation.
     * @callback module:api/ContactApi~exportContactsCallback
     * @param {String} error Error message, if any.
     * @param {module:model/CreateContactsExportResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Create a Contacts Export
     * Create a Contacts Export to a CSV file.
     * @param {Number} listId 
     * @param {Object} opts Optional parameters
     * @param {Number} opts.accountId 
     * @param {String} opts.description 
     * @param {String} opts.query 
     * @param {String} opts.fiql 
     * @param {String} opts.json 
     * @param {Number} opts.segmentId 
     * @param {String} opts.filter Valid Terms:   - `status`   - `email`  Valid Operators:   - `==`  Query separator:   - `;`
     * @param {module:api/ContactApi~exportContactsCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/CreateContactsExportResponse}
     */

  }, {
    key: "exportContacts",
    value: function exportContacts(listId, opts, callback) {
      opts = opts || {};
      var postBody = null; // verify the required parameter 'listId' is set

      if (listId === undefined || listId === null) {
        throw new Error("Missing the required parameter 'listId' when calling exportContacts");
      }

      var pathParams = {
        'list_id': listId
      };
      var queryParams = {
        'account_id': opts['accountId'],
        'description': opts['description'],
        'query': opts['query'],
        'fiql': opts['fiql'],
        'json': opts['json'],
        'segment_id': opts['segmentId'],
        'filter': opts['filter']
      };
      var headerParams = {};
      var formParams = {};
      var authNames = ['OAuth2PasswordBearer'];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = _CreateContactsExportResponse["default"];
      return this.apiClient.callApi('/lists/{list_id}/exports', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null, callback);
    }
    /**
     * Callback function to receive the result of the getContact operation.
     * @callback module:api/ContactApi~getContactCallback
     * @param {String} error Error message, if any.
     * @param {module:model/ContactResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Show a contact details
     * @param {Number} listId 
     * @param {Number} contactId 
     * @param {Object} opts Optional parameters
     * @param {Number} opts.accountId 
     * @param {module:api/ContactApi~getContactCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/ContactResponse}
     */

  }, {
    key: "getContact",
    value: function getContact(listId, contactId, opts, callback) {
      opts = opts || {};
      var postBody = null; // verify the required parameter 'listId' is set

      if (listId === undefined || listId === null) {
        throw new Error("Missing the required parameter 'listId' when calling getContact");
      } // verify the required parameter 'contactId' is set


      if (contactId === undefined || contactId === null) {
        throw new Error("Missing the required parameter 'contactId' when calling getContact");
      }

      var pathParams = {
        'list_id': listId,
        'contact_id': contactId
      };
      var queryParams = {
        'account_id': opts['accountId']
      };
      var headerParams = {};
      var formParams = {};
      var authNames = ['OAuth2PasswordBearer'];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = _ContactResponse["default"];
      return this.apiClient.callApi('/lists/{list_id}/contacts/{contact_id}', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null, callback);
    }
    /**
     * Callback function to receive the result of the getContactsExport operation.
     * @callback module:api/ContactApi~getContactsExportCallback
     * @param {String} error Error message, if any.
     * @param {module:model/ContactsExportResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Show a Contacts Export
     * Show a Contacts Export.
     * @param {String} exportId 
     * @param {Number} listId 
     * @param {Object} opts Optional parameters
     * @param {Number} opts.accountId 
     * @param {module:api/ContactApi~getContactsExportCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/ContactsExportResponse}
     */

  }, {
    key: "getContactsExport",
    value: function getContactsExport(exportId, listId, opts, callback) {
      opts = opts || {};
      var postBody = null; // verify the required parameter 'exportId' is set

      if (exportId === undefined || exportId === null) {
        throw new Error("Missing the required parameter 'exportId' when calling getContactsExport");
      } // verify the required parameter 'listId' is set


      if (listId === undefined || listId === null) {
        throw new Error("Missing the required parameter 'listId' when calling getContactsExport");
      }

      var pathParams = {
        'export_id': exportId,
        'list_id': listId
      };
      var queryParams = {
        'account_id': opts['accountId']
      };
      var headerParams = {};
      var formParams = {};
      var authNames = ['OAuth2PasswordBearer'];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = _ContactsExportResponse["default"];
      return this.apiClient.callApi('/lists/{list_id}/exports/{export_id}', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null, callback);
    }
    /**
     * Callback function to receive the result of the importContacts operation.
     * @callback module:api/ContactApi~importContactsCallback
     * @param {String} error Error message, if any.
     * @param {module:model/ImportContactsResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Import contacts
     * Synchronize your own list with Cakemail by importing to your active, unsubscribed or delete contacts.
     * @param {Number} listId 
     * @param {module:model/ImportContacts} importContacts 
     * @param {Object} opts Optional parameters
     * @param {Number} opts.accountId 
     * @param {module:model/DoubleOptIn} opts.sendDoubleOptIn 
     * @param {module:api/ContactApi~importContactsCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/ImportContactsResponse}
     */

  }, {
    key: "importContacts",
    value: function importContacts(listId, _importContacts, opts, callback) {
      opts = opts || {};
      var postBody = _importContacts; // verify the required parameter 'listId' is set

      if (listId === undefined || listId === null) {
        throw new Error("Missing the required parameter 'listId' when calling importContacts");
      } // verify the required parameter 'importContacts' is set


      if (_importContacts === undefined || _importContacts === null) {
        throw new Error("Missing the required parameter 'importContacts' when calling importContacts");
      }

      var pathParams = {
        'list_id': listId
      };
      var queryParams = {
        'account_id': opts['accountId'],
        'send_double_opt_in': opts['sendDoubleOptIn']
      };
      var headerParams = {};
      var formParams = {};
      var authNames = ['OAuth2PasswordBearer'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = _ImportContactsResponse["default"];
      return this.apiClient.callApi('/lists/{list_id}/import-contacts', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null, callback);
    }
    /**
     * Callback function to receive the result of the listContactsExports operation.
     * @callback module:api/ContactApi~listContactsExportsCallback
     * @param {String} error Error message, if any.
     * @param {module:model/ContactsExportsResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Show all Contacts Exports
     * Show all Contacts Exports.
     * @param {Number} listId 
     * @param {Object} opts Optional parameters
     * @param {Number} opts.accountId 
     * @param {Number} opts.page  (default to 1)
     * @param {Number} opts.perPage  (default to 50)
     * @param {Boolean} opts.withCount  (default to false)
     * @param {String} opts.sort Sort term and direction, using syntax `[-|+]term`.  Valid terms:   - `status`   - `created_on`   - `expires_on`
     * @param {String} opts.filter Valid Terms:   - `status`   - `progress`  Valid Operators:   - `==`  Query separator:   - `;`
     * @param {module:api/ContactApi~listContactsExportsCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/ContactsExportsResponse}
     */

  }, {
    key: "listContactsExports",
    value: function listContactsExports(listId, opts, callback) {
      opts = opts || {};
      var postBody = null; // verify the required parameter 'listId' is set

      if (listId === undefined || listId === null) {
        throw new Error("Missing the required parameter 'listId' when calling listContactsExports");
      }

      var pathParams = {
        'list_id': listId
      };
      var queryParams = {
        'account_id': opts['accountId'],
        'page': opts['page'],
        'per_page': opts['perPage'],
        'with_count': opts['withCount'],
        'sort': opts['sort'],
        'filter': opts['filter']
      };
      var headerParams = {};
      var formParams = {};
      var authNames = ['OAuth2PasswordBearer'];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = _ContactsExportsResponse["default"];
      return this.apiClient.callApi('/lists/{list_id}/exports', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null, callback);
    }
    /**
     * Callback function to receive the result of the listContactsOfList operation.
     * @callback module:api/ContactApi~listContactsOfListCallback
     * @param {String} error Error message, if any.
     * @param {module:model/ContactsResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Show all contacts
     * @param {Number} listId 
     * @param {Object} opts Optional parameters
     * @param {Number} opts.accountId 
     * @param {Number} opts.page 
     * @param {Number} opts.perPage  (default to 50)
     * @param {Boolean} opts.withCount  (default to false)
     * @param {String} opts.query SQL selection query (only use one of query, fiql and json)
     * @param {String} opts.fiql FIQL selection expression (only use one of query, fiql and json)
     * @param {String} opts.json JSON selection expression (only use one of query, fiql and json)
     * @param {String} opts.cursor Cursor pagination
     * @param {String} opts.sort Sort term and direction, using syntax `[-|+]term`.  Valid terms:   - `id`   - `email`   - `status`   - `subscribed_on`   - `last_bounce_type`   - `bounces_count`
     * @param {String} opts.filter Valid Terms:   - `status`   - `email`  Valid Operators:   - `==`  Query separator:   - `;`
     * @param {module:api/ContactApi~listContactsOfListCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/ContactsResponse}
     */

  }, {
    key: "listContactsOfList",
    value: function listContactsOfList(listId, opts, callback) {
      opts = opts || {};
      var postBody = null; // verify the required parameter 'listId' is set

      if (listId === undefined || listId === null) {
        throw new Error("Missing the required parameter 'listId' when calling listContactsOfList");
      }

      var pathParams = {
        'list_id': listId
      };
      var queryParams = {
        'account_id': opts['accountId'],
        'page': opts['page'],
        'per_page': opts['perPage'],
        'with_count': opts['withCount'],
        'query': opts['query'],
        'fiql': opts['fiql'],
        'json': opts['json'],
        'cursor': opts['cursor'],
        'sort': opts['sort'],
        'filter': opts['filter']
      };
      var headerParams = {};
      var formParams = {};
      var authNames = ['OAuth2PasswordBearer'];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = _ContactsResponse["default"];
      return this.apiClient.callApi('/lists/{list_id}/contacts', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null, callback);
    }
    /**
     * Callback function to receive the result of the listContactsOfSegment operation.
     * @callback module:api/ContactApi~listContactsOfSegmentCallback
     * @param {String} error Error message, if any.
     * @param {module:model/ContactsResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Show all contacts in a segment
     * @param {Number} segmentId 
     * @param {Number} listId 
     * @param {Object} opts Optional parameters
     * @param {Number} opts.accountId 
     * @param {Number} opts.page 
     * @param {Number} opts.perPage  (default to 50)
     * @param {Boolean} opts.withCount  (default to false)
     * @param {String} opts.query SQL selection query (only use one of query, fiql and json)
     * @param {String} opts.fiql FIQL selection expression (only use one of query, fiql and json)
     * @param {String} opts.json JSON selection expression (only use one of query, fiql and json)
     * @param {String} opts.cursor Cursor pagination
     * @param {String} opts.sort Sort term and direction, using syntax `[-|+]term`.  Valid terms:   - `id`   - `email`   - `status`   - `subscribed_on`   - `last_bounce_type`   - `bounces_count`
     * @param {String} opts.filter Valid Terms:   - `status`   - `email`  Valid Operators:   - `==`  Query separator:   - `;`
     * @param {module:api/ContactApi~listContactsOfSegmentCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/ContactsResponse}
     */

  }, {
    key: "listContactsOfSegment",
    value: function listContactsOfSegment(segmentId, listId, opts, callback) {
      opts = opts || {};
      var postBody = null; // verify the required parameter 'segmentId' is set

      if (segmentId === undefined || segmentId === null) {
        throw new Error("Missing the required parameter 'segmentId' when calling listContactsOfSegment");
      } // verify the required parameter 'listId' is set


      if (listId === undefined || listId === null) {
        throw new Error("Missing the required parameter 'listId' when calling listContactsOfSegment");
      }

      var pathParams = {
        'segment_id': segmentId,
        'list_id': listId
      };
      var queryParams = {
        'account_id': opts['accountId'],
        'page': opts['page'],
        'per_page': opts['perPage'],
        'with_count': opts['withCount'],
        'query': opts['query'],
        'fiql': opts['fiql'],
        'json': opts['json'],
        'cursor': opts['cursor'],
        'sort': opts['sort'],
        'filter': opts['filter']
      };
      var headerParams = {};
      var formParams = {};
      var authNames = ['OAuth2PasswordBearer'];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = _ContactsResponse["default"];
      return this.apiClient.callApi('/lists/{list_id}/segments/{segment_id}/contacts', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null, callback);
    }
    /**
     * Callback function to receive the result of the patchContact operation.
     * @callback module:api/ContactApi~patchContactCallback
     * @param {String} error Error message, if any.
     * @param {module:model/PatchContactResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Update a contact
     * @param {Number} listId 
     * @param {Number} contactId 
     * @param {module:model/PatchContact} patchContact 
     * @param {Object} opts Optional parameters
     * @param {Number} opts.accountId 
     * @param {module:api/ContactApi~patchContactCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/PatchContactResponse}
     */

  }, {
    key: "patchContact",
    value: function patchContact(listId, contactId, _patchContact, opts, callback) {
      opts = opts || {};
      var postBody = _patchContact; // verify the required parameter 'listId' is set

      if (listId === undefined || listId === null) {
        throw new Error("Missing the required parameter 'listId' when calling patchContact");
      } // verify the required parameter 'contactId' is set


      if (contactId === undefined || contactId === null) {
        throw new Error("Missing the required parameter 'contactId' when calling patchContact");
      } // verify the required parameter 'patchContact' is set


      if (_patchContact === undefined || _patchContact === null) {
        throw new Error("Missing the required parameter 'patchContact' when calling patchContact");
      }

      var pathParams = {
        'list_id': listId,
        'contact_id': contactId
      };
      var queryParams = {
        'account_id': opts['accountId']
      };
      var headerParams = {};
      var formParams = {};
      var authNames = ['OAuth2PasswordBearer'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = _PatchContactResponse["default"];
      return this.apiClient.callApi('/lists/{list_id}/contacts/{contact_id}', 'PATCH', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null, callback);
    }
    /**
     * Callback function to receive the result of the unsubscribeContact operation.
     * @callback module:api/ContactApi~unsubscribeContactCallback
     * @param {String} error Error message, if any.
     * @param {module:model/UnsubscribeContactResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Unsubscribe a contact from a list
     * @param {Number} listId 
     * @param {Number} contactId 
     * @param {Object} opts Optional parameters
     * @param {Number} opts.accountId 
     * @param {module:api/ContactApi~unsubscribeContactCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/UnsubscribeContactResponse}
     */

  }, {
    key: "unsubscribeContact",
    value: function unsubscribeContact(listId, contactId, opts, callback) {
      opts = opts || {};
      var postBody = null; // verify the required parameter 'listId' is set

      if (listId === undefined || listId === null) {
        throw new Error("Missing the required parameter 'listId' when calling unsubscribeContact");
      } // verify the required parameter 'contactId' is set


      if (contactId === undefined || contactId === null) {
        throw new Error("Missing the required parameter 'contactId' when calling unsubscribeContact");
      }

      var pathParams = {
        'list_id': listId,
        'contact_id': contactId
      };
      var queryParams = {
        'account_id': opts['accountId']
      };
      var headerParams = {};
      var formParams = {};
      var authNames = ['OAuth2PasswordBearer'];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = _UnsubscribeContactResponse["default"];
      return this.apiClient.callApi('/lists/{list_id}/contacts/{contact_id}/unsubscribe', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null, callback);
    }
  }]);

  return ContactApi;
}();

exports["default"] = ContactApi;